import { createApp } from 'utils/vue';
import App from "components/user_profile/container";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App, app.data).mount("#app-container");
};

registerHandler("user_profile/index", handler);
